/**
 * Configurazione AWS Cognito e provider di credenziali per l'autenticazione federata.
 * Questo modulo esporta la regione AWS e un provider di credenziali configurato per l'accesso autenticato tramite Cognito Identity Pool.
 */
import {
  fromCognitoIdentityPool,
  type FromCognitoIdentityPoolParameters,
} from "@aws-sdk/credential-providers";
import { userManager } from "./userManager";

/**
 * Regione AWS utilizzata per i servizi.
 */
export const region = import.meta.env.VITE_REGION;

/**
 * Parametri per la configurazione del provider di credenziali Cognito Identity Pool.
 * - identityPoolId: ID del pool di identità Cognito
 * - logins: mappa dei provider di identità federata (es. Cognito User Pool)
 * - clientConfig: configurazione client AWS (es. regione)
 */
const fromCognitoIdentityPoolParams: FromCognitoIdentityPoolParameters = {
  // Required. The unique identifier for the identity against which credentials
  // will be issued.
  identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL as string,
  logins: {},
  clientConfig: {
    region,
  },
};

/**
 * Provider di credenziali AWS configurato per autenticazione federata tramite Cognito.
 * Utilizza il token dell'utente autenticato per ottenere credenziali temporanee AWS.
 */
export const credentialProvider = fromCognitoIdentityPool({
  ...fromCognitoIdentityPoolParams,
  logins: {
    [import.meta.env.VITE_COGNITO_ID_PROVIDER as string]: () =>
      userManager.getUser().then((user) => user!.id_token!),
  },
});
